/* Preset engraving icons — 24x24 viewBox path data */
const circle = (cx, cy, r) => `M${cx + r},${cy} A${r},${r} 0 1 1 ${cx - r},${cy} A${r},${r} 0 1 1 ${cx + r},${cy} Z`;

const flowerPetals = () => {
  let d = "";
  for (let i = 0; i < 5; i++) {
    const a = (-90 + i * 72) * (Math.PI / 180);
    d += circle(+(12 + 5.7 * Math.cos(a)).toFixed(1), +(11.5 + 5.7 * Math.sin(a)).toFixed(1), 3.6) + " ";
  }
  return d + circle(12, 11.5, 2.6);
};

const starPath = (cx, cy, points, rO, rI, rot = 0) => {
  let d = "";
  for (let i = 0; i < points * 2; i++) {
    const r = i % 2 === 0 ? rO : rI;
    const a = (rot + (i * 180) / points - 90) * (Math.PI / 180);
    d += `${i === 0 ? "M" : "L"}${(cx + r * Math.cos(a)).toFixed(2)},${(cy + r * Math.sin(a)).toFixed(2)} `;
  }
  return d + "Z";
};

export const TAG_ICONS = {
  flower: { label: "FLOWER", d: flowerPetals() },
  dahlia: { label: "DAHLIA", d: `${starPath(12, 12, 8, 10, 4.8)} ${starPath(12, 12, 8, 6.4, 3.1, 11.25)} ${circle(12, 12, 1.9)}` },
  bee: {
    label: "BEE",
    d: `M12,7.5 C15.2,7.5 16.8,10.4 16.8,14 C16.8,17.8 14.8,20.8 12,20.8 C9.2,20.8 7.2,17.8 7.2,14 C7.2,10.4 8.8,7.5 12,7.5 Z ${circle(12, 5.4, 2.2)} M10.6,8.6 C6.5,5.5 2.8,7.5 4.3,10.2 C5.4,12.2 8.6,12 10.9,10.4 Z M13.4,8.6 C17.5,5.5 21.2,7.5 19.7,10.2 C18.6,12.2 15.4,12 13.1,10.4 Z M11.2,20.6 L12,23.2 L12.8,20.6 Z`,
  },
  watering_can: {
    label: "WATERING CAN",
    d: `M6.5,9.5 L16,9.5 L16,18 Q16,20 14,20 L8.5,20 Q6.5,20 6.5,18 Z M9,9.5 C9,6.3 13.5,6.3 13.5,9.5 L12.1,9.5 C12.1,7.7 10.4,7.7 10.4,9.5 Z M6.8,13 L2.6,8.5 L4.2,7 L7.5,10.6 Z ${circle(3.2, 7.5, 1.8)} M16,11 C19.8,11 19.8,16.4 16,16.4 L16,14.8 C17.8,14.8 17.8,12.6 16,12.6 Z`,
  },
  tulip: {
    label: "TULIP",
    d: "M7,3.5 C9,5.5 10.5,6.8 12,8.8 C13.5,6.8 15,5.5 17,3.5 C20,6 20.5,11 17.2,13.2 C15.2,14.6 13.2,14.3 12,13 C10.8,14.3 8.8,14.6 6.8,13.2 C3.5,11 4,6 7,3.5 Z M11.2,14.5 L12.8,14.5 L12.8,21 L11.2,21 Z",
  },
  leaf: {
    label: "LEAF",
    d: "M12,2.5 C18,6 20.5,13 15.5,20 C13.5,22 10,21.5 8.5,19 C4.5,12.5 7,5.5 12,2.5 Z",
  },
  sprout: {
    label: "SPROUT",
    d: "M11.2,12 L12.8,12 L12.8,21 L11.2,21 Z M12,12.5 C12,7.5 15.5,4 20.5,4 C20.5,9 17,12.5 12,12.5 Z M12,12.5 C12,8.5 9.2,5.8 4.5,5.8 C4.5,10.2 7.5,12.5 12,12.5 Z",
  },
  heart: {
    label: "HEART",
    d: "M12,20.5 C5.5,15 2.5,10.5 4.8,7 C6.8,4.2 10.2,4.6 12,7.5 C13.8,4.6 17.2,4.2 19.2,7 C21.5,10.5 18.5,15 12,20.5 Z",
  },
  star: {
    label: "STAR",
    d: "M12,2.5 L14.7,8.6 L21.3,9.2 L16.3,13.6 L17.8,20.1 L12,16.7 L6.2,20.1 L7.7,13.6 L2.7,9.2 L9.3,8.6 Z",
  },
  sun: {
    label: "SUN",
    d: `${circle(12, 12, 5)} M11.2,1 L12.8,1 L12.8,5 L11.2,5 Z M11.2,19 L12.8,19 L12.8,23 L11.2,23 Z M1,11.2 L5,11.2 L5,12.8 L1,12.8 Z M19,11.2 L23,11.2 L23,12.8 L19,12.8 Z M4.2,5.3 L5.3,4.2 L8.1,7 L7,8.1 Z M15.9,17 L17,15.9 L19.8,18.7 L18.7,19.8 Z M18.7,4.2 L19.8,5.3 L17,8.1 L15.9,7 Z M5.3,19.8 L4.2,18.7 L7,15.9 L8.1,17 Z`,
  },
  moon: {
    label: "MOON",
    d: "M14.5,2.5 A9.5,9.5 0 1 0 21.5,14.5 A7.5,7.5 0 0 1 14.5,2.5 Z",
  },
  butterfly: {
    label: "BUTTERFLY",
    d: "M11.2,7 C8.5,2.5 3,2.5 3,7 C3,10.5 7.5,12.3 11.2,13.2 L11.2,20.5 L12.8,20.5 L12.8,13.2 C16.5,12.3 21,10.5 21,7 C21,2.5 15.5,2.5 12.8,7 Z",
  },
};
